import React from "react";

import { Breadcrumb as DSBreadcrumb } from "@olist/design-system";

interface IPropsBreadcrumb {
  items: { text: string; link?: string; onClick?: () => void }[];
  shouldRender?: boolean;
}

export function Breadcrumb({ items, shouldRender }: IPropsBreadcrumb) {
  if (shouldRender === false) {
    return null;
  }

  return (
    <DSBreadcrumb
      items={items}
      rootElement={{ text: "produtos", link: "/kb" }}
    />
  );
}
